export const SERVER_URL = 'https://resident-data-api.wastecambodia.com'
